import { useContext } from "react";

import {
  ToastNotificationServiceContext,
  ToastNotificationServiceContextType,
} from "../contexts/toastNotificationServiceContext";

const useToastNotificationService = (): ToastNotificationServiceContextType => {
  const context = useContext(ToastNotificationServiceContext);
  if (context === undefined) {
    throw new Error(
      "useToastNotificationService must be used within a ToastNotificationServiceProvider",
    );
  }
  return context;
};

export default useToastNotificationService;
